"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureFieldLogic = void 0;
const filesize_1 = __importDefault(require("filesize"));
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const signature_1 = require("../../aggregations/signature");
const field_logic_1 = require("../../field-type-registry/field-logic");
const comparisons_1 = require("../../comparisons/comparisons");
const intl_1 = require("../../locale/intl");
const signature_fieldtype_1 = require("../../safe-field-value/signature-field/signature.fieldtype");
const texts_1 = require("../../texts");
const validation_1 = require("../../validation/validation");
class SignatureFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor(config) {
        super(config);
        this.aggregates = {
            empty: { label: (0, intl_1.$t)(texts_1.aggregatesText.empty), aggregator: field_logic_1.countEmpty },
            "non-empty": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.non_empty),
                aggregator: field_logic_1.countFilled,
            },
            "percent-filled": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.percent_filled),
                aggregator: field_logic_1.percentFilled,
            },
            "percent-empty": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.percent_empty),
                aggregator: field_logic_1.percentEmpty,
            },
            "total-attachments": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.total_number_of_attachments),
                aggregator: (0, signature_1.signatureAggregate)((files) => String(files.length)),
            },
            "total-attachments-size": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.total_attachment_size),
                aggregator: (0, signature_1.signatureAggregate)((files) => {
                    const totalSize = files.reduce((acc, file) => acc + ((file === null || file === void 0 ? void 0 : file.metadata.size) || 0), 0);
                    return (0, filesize_1.default)(totalSize);
                }),
            },
        };
        this.name = "signaturefield";
        this.icon = "signature";
        this.iconColor = "#4ECCFD";
        this.label = (0, intl_1.$t)(texts_1.signatureFieldText.signature);
        this.groupByMode = "groupBy";
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is_empty: () => (value) => !(0, comparisons_1.isSignatureHasValue)(value),
            is_not_empty: () => (value) => (0, comparisons_1.isSignatureHasValue)(value),
        };
        this.fieldValueGetter = new signature_fieldtype_1.SignatureFieldValueGetter();
        this.defaultMaxLength = config.default_max_length;
    }
    get validators() {
        return { required: validation_1.requiredSignature };
    }
    valueToString(value) {
        return (0, comparisons_1.isSignatureHasValue)(value)
            ? (0, intl_1.$t)(texts_1.signatureFieldText.signed)
            : (0, intl_1.$t)(texts_1.signatureFieldText.unsigned);
    }
    sortKey(value) {
        var _a, _b;
        return [
            (0, comparisons_1.isSignatureHasValue)(value) ? "a" : "b",
            (_a = value === null || value === void 0 ? void 0 : value.text) !== null && _a !== void 0 ? _a : "",
            (_b = value === null || value === void 0 ? void 0 : value.image_base64) !== null && _b !== void 0 ? _b : "",
        ];
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            editorWidth: "371px",
            editOnStartTyping: false,
            allowAddRecordToGroup: false,
            canBulkClean(field) {
                return true;
            },
        };
    }
    getEmptyValue() {
        return { drawing: [] };
    }
    isValueEmpty(fieldValue, _field) {
        return !(0, comparisons_1.isSignatureHasValue)(fieldValue);
    }
    isValueEqual(fieldValue1, fieldValue2) {
        if (!!(fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.text) || !!(fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.text)) {
            return (fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.text) === (fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.text);
        }
        if (!!(fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.image_base64) || !!(fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.image_base64)) {
            return (fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.image_base64) === (fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.image_base64);
        }
        return (0, react_fast_compare_1.default)(fieldValue1, fieldValue2);
    }
    processSearch(searchTerm, fieldValue, field, userPreferences, record) {
        const lowerTerm = searchTerm.trim().toLowerCase();
        if (!lowerTerm) {
            return false;
        }
        const preparedFieldValue = this.searchKey(fieldValue, field, userPreferences, record);
        return preparedFieldValue.toLowerCase().startsWith(lowerTerm);
    }
    canChangeValue() {
        return false;
    }
    getDuplicateFieldOptions() {
        return {
            includeContentChecked: false,
            includeContentDisabled: true,
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 120,
            minWidth: 60,
        };
    }
}
exports.SignatureFieldLogic = SignatureFieldLogic;
